<template>
	<div>
		<div class="schedule">
			<div class="schedule-controls">
				{{ startOfWeek | moment('DD [de] MMMM') }} - {{ endOfWeek | moment('DD [de] MMMM') }}
				<div class="buttons">
					<div class="btn ml-1 btn-sm btn-light" @click="prevWeek"><i class="icon-left-open-1"></i></div>
					<div class="btn btn-sm btn-light" @click="nextWeek"><i class="icon-right-open-1"></i></div>
				</div>
			</div>

			<div class="schedule-table" v-if="!loading">
				<table class="table">
					<tr class="head">
						<td v-for="day in days" :key="day.id">
							{{ day.date | moment('dddd') }} <br /><small>{{ day.date | moment('DD-MM') }}</small>
						</td>
					</tr>
					<tr>
						<td v-for="day in days" :key="day.id">
							<div v-for="slot in day.slots" :key="slot.id">
								<div
									class="hour"
									:class="{
										selected: slot.id == selectedSlot.id,
										'channel-mix': slot.channel == 'mix',
										'channel-video': slot.channel == 'video',
										'channel-presential': slot.channel == 'presential',
									}"
									@click="selectHour(slot)"
								>
									<template v-if="activeChannel && activeChannel == 'presential'">
										<div class="channel-presential" v-if="slot.channel == 'presential' || slot.channel == 'mix'">
											<i class="icon_house"></i>
										</div>
									</template>

									<template v-if="activeChannel && activeChannel == 'video'">
										<div class="channel-video" v-if="slot.channel == 'video' || slot.channel == 'mix'">
											<i class="icon-videocam"></i>
										</div>
									</template>

									<template v-if="!activeChannel">
										<div class="channel-presential" v-if="slot.channel == 'presential'">
											<i class="icon_house"></i>
										</div>
										<div class="channel-video" v-if="slot.channel == 'video'">
											<i class="icon-videocam"></i>
										</div>
										<div class="channel-mix" v-if="slot.channel == 'mix'">
											<div><i class="icon_house"></i></div>
											<div><i class="icon-videocam"></i></div>
										</div>
									</template>

									<div class="label">
										{{ slot.datetime | moment('HH:mm') }}
									</div>
								</div>
							</div>
						</td>
					</tr>
				</table>
			</div>

			<div class="schedule-controls" v-if="!loading && timeslots.length > 0">
				{{ startOfWeek | moment('DD [de] MMMM') }} - {{ endOfWeek | moment('DD [de] MMMM') }}
				<div class="buttons">
					<div class="btn ml-1 btn-sm btn-light" @click="prevWeek"><i class="icon-left-open-1"></i></div>
					<div class="btn btn-sm btn-light" @click="nextWeek"><i class="icon-right-open-1"></i></div>
				</div>
			</div>

			<div class="loading alert alert-warning mt-4 mb-4" v-if="loading">
				Cargando horas disponibles
			</div>

			<div class="loading alert alert-danger mt-4 mb-4" v-if="!loading && timeslots.length == 0">
				No se encontraron horas disponibles para esta semana
			</div>
		</div>
	</div>
</template>

<script>
import gql from 'graphql-tag'

export default {
	name: 'Calendar',
	components: {},
	props: ['medicId', 'selectedDatetime', 'type', 'activeChannel'],
	data() {
		return {
			now: this.$moment(new Date(), 'DD-MM-YYYY HH:mm').add(24, 'h'),
			today: this.$moment(new Date(), 'DD-MM-YYYY').add(24, 'h'),
			startOfThisWeek: this.$moment(new Date(), 'DD-MM-YYYY 00:00:00')
				.add(24, 'h')
				.set('hour', 0)
				.set('minute', 0)
				.set('second', 0),
			startOfWeek: this.$moment(new Date(), 'DD-MM-YYYY').add(24, 'h'),
			endOfWeek: this.$moment(new Date(), 'DD-MM-YYYY').add(8, 'd'),
			days: [],
			hasChanges: false,
			filters: {
				showOnlyBookeables: false,
			},
			loading: true,
			selectedSlot: {},
		}
	},
	created() {
		//this.initWeek();
		if (this.selectedDatetime) {
			this.loading = true
			this.startOfWeek = this.$moment(this.selectedDatetime).clone()
			this.endOfWeek = this.$moment(this.selectedDatetime)
				.clone()
				.add(7, 'd')
		}
		this.$apollo.queries.timeslots.skip = false

		if (this.$route.query.debug) {
			this.startOfWeek = this.$moment(new Date(), 'DD-MM-YYYY')
		}
	},
	apollo: {
		timeslots: {
			query: gql`
				query($medic_id: ID!, $type: Int, $start_date: String!, $end_date: String!) {
					timeslots(medic_id: $medic_id, type: $type, status: "0", start_date: $start_date, end_date: $end_date) {
						id
						datetime
						channel
						status
					}
				}
			`,
			watchLoading(isLoading) {
				this.loading = isLoading
			},
			variables() {
				return {
					medic_id: this.medicId,
					type: this.type,
					start_date: this.$moment(this.startOfWeek).format('YYYY-MM-DD HH:mm:00'),
					end_date: this.$moment(this.endOfWeek).format('YYYY-MM-DD 23:59:59'),
				}
			},
			skip: true,
			fetchPolicy: 'no-cache',
			result(data) {
				console.log(data)
				//this.me = data.data.medic;
				this.loading = false
				this.initWeek()
			},
		},
	},
	methods: {
		initWeek() {
			this.days = []
			let day = this.startOfWeek
			let newDay = {}
			newDay.date = this.$moment(day, 'DD-MM-YYYY')
			newDay.slots = []
			this.days.push(newDay)
			var i = 1
			for (i; i < 7; i++) {
				day = day.clone().add(1, 'd')
				let newDay = {}
				newDay.date = this.$moment(day, 'DD-MM-YYYY')
				newDay.slots = []
				this.days.push(newDay)
			}
			this.loadSlotsIntoWeek()
		},
		nextWeek() {
			this.loading = true
			let startOfWeek = this.startOfWeek.clone().add(7, 'd')
			// si el start of week es mayor a hoy, inicia desde las 00 horas.
			if (startOfWeek > this.now) {
				startOfWeek = this.$moment(startOfWeek)
					.set('hour', 0)
					.set('minute', 0)
					.set('second', 0)
			}
			this.startOfWeek = startOfWeek
			this.endOfWeek = this.endOfWeek.clone().add(7, 'd')

			this.selectHour({})
		},
		prevWeek() {
			let nextWeekStart = this.startOfWeek.clone().subtract(7, 'd')
			if (this.startOfThisWeek <= nextWeekStart) {
				this.loading = true
				if (nextWeekStart < this.now) {
					nextWeekStart = this.now.clone()
				}

				this.startOfWeek = nextWeekStart
				this.endOfWeek = this.endOfWeek.clone().subtract(7, 'd')
			}
			this.selectHour({})
		},
		loadSlotsIntoWeek() {
			this.timeslots.forEach((timeslot) => {
				this.findDayToPushSlot(timeslot)
			})
		},
		findDayToPushSlot(timeslot) {
			this.days.forEach((day) => {
				if (this.$moment(timeslot.datetime).format('MM/DD/YYYY') == this.$moment(day.date).format('MM/DD/YYYY')) {
					if (timeslot.datetime == this.selectedDatetime) {
						this.selectHour(timeslot)
					}
					day.slots.push(timeslot)
				}
			})
		},
		selectHour(slot) {
			this.selectedSlot = slot
			this.$emit('selected', slot)
		},
	},
	beforeRouteLeave(to, from, next) {
		if (this.hasChanges) {
			const answer = window.confirm('¿De verdad quieres irte? Usted tiene cambios no guardados!')
			if (answer) {
				next()
			} else {
				next(false)
			}
		} else {
			next()
		}
	},
}
</script>

<style scoped>
.schedule {
	margin: 16px 0px;
}

.schedule-controls {
	font-size: 18px;
	padding: 8px 0px;
	display: flex;
	justify-content: space-between;
}

.schedule-controls .buttons {
}

.schedule-table {
	width: 100%;
	overflow: auto;
}
.schedule-table .head {
	text-transform: uppercase;
	text-align: center;
	font-size: 13px;
}
.schedule-table tr:not(.head) {
	background-color: #f1f1f1;
}

.schedule-table .head td {
	flex-grow: 0;
	flex-shrink: 0;
	width: 14.2%;
	min-width: 92px;
	padding: 0.75rem 0px;
}
.schedule-table .head td small {
	font-size: 14px;
	font-weight: 500;
}
.schedule-table tr:not(.head) td {
	padding: 0px;
}

.schedule-table .hour {
	text-align: center;
	background-color: #79e692;
	border-radius: 4px;
	padding: 5px 40px;
	height: 26px;
	margin: 2px;
	cursor: pointer;
	user-select: none;
	position: relative;
	overflow: hidden;
}

.schedule-table .hour .label {
	user-select: none;
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.schedule-table .hour .channel-presential {
	width: 100%;
	height: 100%;
	top: 0px;
	left: 0px;
	z-index: 0;
	position: absolute;
	background-color: #9fe8b0;
	text-align: left;
	padding: 3px;
	color: #57d072;
}

.schedule-table .hour .channel-video {
	width: 100%;
	height: 100%;
	top: 0px;
	left: 0px;
	z-index: 0;
	position: absolute;
	background-color: #b0dbf9;
	text-align: right;
	padding: 3px;
	color: #82b0cc;
}

.schedule-table .hour .channel-mix > div:first-child {
	width: 50%;
	height: 100%;
	top: 0px;
	left: 0px;
	z-index: 0;
	position: absolute;
	text-align: left;
	padding: 3px;
	color: #57d072;
}
.schedule-table .hour .channel-mix > div:last-child {
	width: 50%;
	height: 100%;
	top: 0px;
	right: 0px;
	z-index: 0;
	position: absolute;
	background-color: #b0dbf9;
	text-align: right;
	padding: 3px;
	color: #82b0cc;
}

.schedule-table .hour.selected .label {
	color: #ffffff;
	font-weight: 600;
}
.schedule-table .hour.selected .channel-presential {
	background-color: #4dde6e;
	color: #ffffff;
}
.schedule-table .hour.selected .channel-video {
	background-color: #548cb3;
	color: #ffffff;
}

.schedule-table .hour.selected .channel-mix > div:first-child {
	background-color: #4dde6e;
	color: #ffffff;
}
.schedule-table .hour.selected .channel-mix > div:last-child {
	background-color: #548cb3;
	color: #ffffff;
}
</style>
